import type { ReactNode } from "react";

export const formRequiredMark = (
  label: ReactNode,
  info: { required: boolean },
) => (
  <span style={{ display: "inline-flex", alignItems: "baseline", gap: 4 }}>
    {label}
    {info.required && (
      <span style={{ color: "#9ca3af", fontSize: 12, fontWeight: 400 }}>
        (required)
      </span>
    )}
  </span>
);
